import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  city: string;
  text: string;
}
export function TestimonialCard({
  name,
  age,
  city,
  text
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-orange-50 h-full flex flex-col" data-id="element-8">
      <div className="flex gap-1 mb-4" data-id="element-9">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-10" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-11">"{text}"</p>
      <div className="mt-auto" data-id="element-12">
        <p className="font-semibold text-gray-900" data-id="element-13">
          {name}, {age} años
        </p>
        <p className="text-sm text-gray-500" data-id="element-14">{city}</p>
      </div>
    </div>;
}